import Button from './Button'

export { Button }
export default Button



// WEBPACK FOOTER //
// ./src/components/Button/index.js